import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./image.css";

const ImageCrop = forwardRef(({ url, cropWidth = 500, cropHeight = 500, onCropComplete }, ref) => {
  const [image, setImage] = useState(url);
  const cropperRef = useRef(null);

  useEffect(() => {
    setImage(url);
  }, [url]);

  const getCroppedImg = async () => {
    if (!cropperRef.current) return null;

    const cropper = cropperRef.current.cropper;
    const canvas = document.createElement('canvas');

    // Set your required output width and height here
    canvas.width = cropWidth;
    canvas.height = cropHeight;

    const ctx = canvas.getContext('2d');

    const cropData = cropper.getData();
    const imageElement = cropper.image;

    const imageObj = new Image();
    imageObj.crossOrigin = 'anonymous';
    imageObj.src = imageElement.src;

    return new Promise((resolve, reject) => {
      imageObj.onload = () => {
        ctx.drawImage(
          imageElement,
          cropData.x,
          cropData.y,
          cropData.width,
          cropData.height,
          0,
          0,
          canvas.width,
          canvas.height
        );

        canvas.toBlob(
          blob => {
            if (!blob) {
              console.error('Canvas is empty');
              reject(new Error('Canvas is empty'));
              return;
            }
            resolve(blob);
          },
          'image/jpeg',
          1.0
        );
      };

      imageObj.onerror = error => {
        console.error('Image load error', error);
        reject(error);
      };
    });
  };

  const handleSubmit = async () => {
    try {
      const croppedImage = await getCroppedImg();
      if (croppedImage && typeof onCropComplete === 'function') {
        onCropComplete(croppedImage);
      }
      return croppedImage;
    } catch (error) {
      console.error('Failed to crop image:', error);
      return null;
    }
  };

  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  return (
    <div className="outerDiv">
      <Cropper
        ref={cropperRef}
        style={{ maxWidth: "900px", width: "100%" }}
        initialAspectRatio={1}
        src={image}
        viewMode={1}
        guides={true}
        background={false}
        responsive={true}
        autoCropArea={1}
        checkOrientation={false}
        dragMode="move"    // ✅ Move image, not crop box

        // 🔥 Lock the crop box size:
        cropBoxResizable={false}
        cropBoxMovable={false}
        center={true}

        aspectRatio={cropWidth / cropHeight} // ✅ Lock ratio
      />

    </div>
  );
}
);

export default ImageCrop;
